<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-edit-circle"
    :width="props.width"
    :height="props.height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"
    ></path>
    <path d="M16 5l3 3"></path>
    <path d="M9 7.07a7 7 0 0 0 1 13.93a7 7 0 0 0 6.929 -6"></path>
  </svg>
</template>

<script lang="ts" setup>
export interface IconListProps {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IconListProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
